module.exports = __webpack_public_path__ + "assets/payments.6d32ab37.svg";